module.exports = __webpack_public_path__ + "static/media/person-02.0459ff97.png";